import React from "react";
import Sidebar from "./Sidebar";
import SiteSelector from "./SiteSelector";
import NotificationBell from "./NotificationBell";

export default function Layout({
  children,
  websites,
  selectedSite,
  onSelectSite,
  onLogout,
  userInfo,
}) {
  return (
    <div className="flex min-h-screen bg-dark font-sans">
      <Sidebar onLogout={onLogout} userInfo={userInfo} />

      <div className="flex-1 flex flex-col">
        {/* Top bar */}
        <header className="h-14 bg-dark-300 border-b border-dark-50 flex items-center justify-between px-6">
          <div className="text-sm text-gray-500">
            {userInfo?.organization?.name && (
              <span className="text-gray-400">{userInfo.organization.name}</span>
            )}
          </div>
          <div className="flex items-center gap-4">
            <SiteSelector
              websites={websites}
              selectedSite={selectedSite}
              onSelectSite={onSelectSite}
            />
            <NotificationBell />
            {userInfo?.user && (
              <div className="text-xs text-gray-500 hidden md:block">
                {userInfo.user.email || userInfo.user.username}
              </div>
            )}
          </div>
        </header>

        {/* Main content */}
        <main className="flex-1 p-6 overflow-auto">{children}</main>
      </div>
    </div>
  );
}
